(function () {
  var ROOT_SELECTOR = "#tab_review #judgeme_product_reviews";
  var REVIEW_SELECTOR = ".jdgm-rev-widg__review, .jdgm-rev";
  var CLAMP_CLASS = "ko-review-clamped";
  var EXPANDED_CLASS = "ko-review-expanded";
  var TEXT_CLASS = "ko-review-text";
  var TOGGLE_CLASS = "ko-review-toggle";
  var resizeTimer;

  function isMobileView() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function setCollapsedState(review, body, button) {
    review.classList.remove("ko-review-open");
    body.classList.remove(EXPANDED_CLASS);
    body.classList.add(CLAMP_CLASS);
    button.textContent = "Devamını oku";
  }

  function setExpandedState(review, body, button) {
    review.classList.add("ko-review-open");
    body.classList.remove(CLAMP_CLASS);
    body.classList.add(EXPANDED_CLASS);
    button.textContent = "Daha az göster";
  }

  function needsClamp(textEl) {
    var text = (textEl.textContent || "").trim();
    if (text.length >= 170) return true;
    return textEl.scrollHeight > textEl.clientHeight + 2;
  }

  function findReviewText(review) {
    var candidates = review.querySelectorAll(".jdgm-rev__body p, .jdgm-rev__body, .jdgm-rev__content p, .jdgm-rev__content, p");
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el || !el.textContent) continue;
      if (el.textContent.trim().length < 60) continue;
      if (el.closest(".jdgm-rev__title")) continue;
      return el;
    }
    return null;
  }

  function bindReview(review) {
    var body = findReviewText(review);
    if (!body) return;
    body.classList.add(TEXT_CLASS);
    body.classList.remove(EXPANDED_CLASS);
    body.classList.remove(CLAMP_CLASS);
    review.classList.remove("ko-review-open");

    var toggleButton = review.querySelector("." + TOGGLE_CLASS);
    if (toggleButton) {
      toggleButton.remove();
      toggleButton = null;
    }

    if (isMobileView()) {
      return;
    }

    body.classList.add(CLAMP_CLASS);
    if (!needsClamp(body)) {
      body.classList.remove(CLAMP_CLASS);
      body.classList.remove(EXPANDED_CLASS);
      review.classList.remove("ko-review-open");
      return;
    }

    if (!toggleButton) {
      toggleButton = document.createElement("button");
      toggleButton.type = "button";
      toggleButton.className = TOGGLE_CLASS;
      review.appendChild(toggleButton);
    }

    setCollapsedState(review, body, toggleButton);

    toggleButton.onclick = function () {
      if (body.classList.contains(EXPANDED_CLASS)) {
        setCollapsedState(review, body, toggleButton);
      } else {
        setExpandedState(review, body, toggleButton);
      }
    };
  }

  function processContainer(container) {
    var allReviews = Array.prototype.slice.call(container.querySelectorAll(REVIEW_SELECTOR));
    var reviews = allReviews.filter(function (review) {
      if (review.classList.contains("jdgm-rev")) {
        return !review.closest(".jdgm-rev-widg__review");
      }
      return true;
    });
    if (!reviews.length) return;
    reviews.forEach(bindReview);
  }

  function refreshReviews() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(processContainer);
  }

  function scheduleRefresh() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshReviews, 120);
  }

  function watchContainers() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (container) {
      if (container.dataset.koReviewObserverBound === "1") return;
      container.dataset.koReviewObserverBound = "1";

      var observer = new MutationObserver(function () {
        scheduleRefresh();
      });

      observer.observe(container, { childList: true, subtree: true });
    });
  }

  function init() {
    refreshReviews();
    watchContainers();
  }

  document.addEventListener("click", function (event) {
    var tabTrigger = event.target.closest && event.target.closest('a[href="#tab_review"]');
    if (!tabTrigger) return;
    window.setTimeout(init, 200);
  });

  window.addEventListener("resize", scheduleRefresh);
  document.addEventListener("DOMContentLoaded", init);
  window.setTimeout(init, 600);
})();
